module.exports = __webpack_public_path__ + "static/bird-24def4a0bd9fd2e2580dd522cce9a280.png";